import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { WjNavModule } from '@grapecity/wijmo.angular2.nav';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { AppCommonsModule } from "src/app/commons/app-commons.module";
import { PlessSharedModule } from "src/app/shared/pless-shared.module";
import { KYMW6900Component } from "./kymw6900.component";
import { GetProposalIdService } from "./api-services/get-proposal-id.service";
import { GetClassBuyerIdService } from "./api-services/get-class-buyer-id.service";
import { GetGoodsProposalInfoService } from "./api-services/get-goods-proposal-info.service";
import { RouterModule } from "@angular/router";
import { UpdateSuggestionStatusService } from "./api-services/update-suggestion-status.service";
import { GetSuggestionGoodsOutputService } from "./api-services/get-suggestion-goods-output.service";

/**
 * 商品提案検索画面 モジュール設定クラス
 *
 * @export KYMW6900Module
 * @class KYMW6900Module 
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    WjNavModule,
    WjGridModule,
    AppCommonsModule,
    PlessSharedModule,
  ],
  declarations: [
    KYMW6900Component,
  ],
  providers: [
    GetProposalIdService,
    GetClassBuyerIdService,
    GetGoodsProposalInfoService,
    UpdateSuggestionStatusService,
    GetSuggestionGoodsOutputService
  ],
})

export class KYMW6900Module { }
